import React, { useEffect, useState, Fragment, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import { Button } from 'react-bootstrap';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import CardSection from 'components/sales/cardSection/cardSection';
import DivLayout from 'components/sales/divLayout/divLayout';
import ModalPop from 'components/sales/modal/modal';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import { Link } from 'react-router-dom';
import './pmCheckList.css';

const PmChecklist = ({
  fetchGatesChecklist,
  pmListChecklist,
  match,
  fetchCategoryType,
  typeData,
  fetchSubCategoryType,
  subCategoryType,
  fetchCategory,
  categoryType,
  postPmData,
  location,
  removeIt,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [listData, setlistData] = useState([]);
  const [removeList, setRemoveList] = useState(-1);
  const [modalSuccess, setModalSuccess] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(false);
  const [categoryData, setCategoryData] = useState([]);
  const [materialData, setMaterialData] = useState([]);
  const [addList, setAddList] = useState({
    category_type: '',
    category_id: '',
    category_name: '',
    material_id: '',
    material_name: '',
  });

  useEffect(() => {
    if (subCategoryType !== null) {
      setMaterialData(subCategoryType);
    }
  }, [subCategoryType]);

  useEffect(() => {
    if (categoryType !== null) {
      setCategoryData(categoryType);
    }
  }, [categoryType]);

  useEffect(() => {
    if (
      fetchGatesChecklist !== null &&
      match?.params?.id &&
      location?.state?.gate_id
    )
      (async () => {
        setIsLoading(true);
        await fetchGatesChecklist(match.params.id, location.state.gate_id);
        await fetchCategoryType();

        setIsLoading(false);
      })();
  }, [fetchGatesChecklist, fetchCategoryType]);

  useEffect(() => {
    if (pmListChecklist && pmListChecklist.length > 0) {
      setlistData(pmListChecklist);
    }
  }, [pmListChecklist]);

  const handleModalHide = () => {
    setIsModal(false);
  };

  const modalSuccessHide = () => {
    setModalSuccess(false);
  };

  const addCategory = () => {
    if (addList.category_type !== '') {
      listData[0].details.push(addList);
      setlistData(listData);
      setIsModal(false);
      setCategoryData([]);
      setMaterialData([]);
    }
  };

  useEffect(() => {
    (() => {
      if (removeList !== -1) {
        listData[0].details.splice(removeList, 1);
        setlistData(listData);
        setRemoveList(-1);
      }
    })();
  }, [removeList]);

  const removeCategory = (id) => {
    if (id) {
      const findIndex =
        listData.length &&
        listData[0].details.findIndex((obj) => obj.material_id === id);
      setRemoveList(findIndex);
    }
  };

  const submitData = async () => {
    setIsClicked(true);
    if (listData.length > 0) {
      let checklist = await listData[0].details.map(
        ({ category_type, category_id, material_id }) => ({
          category_type,
          category_id,
          material_id,
        })
      );
      const data = {
        site_id: match.params.id,
        gate_id: location.state.gate_id,
        checklist_answers: checklist,
      };
      const res = await postPmData(data);
      if (res) {
        setModalSuccess(true);
      }
    }
  };

  return (
    <Layout
      title={localization.gateCheckList}
      isGoback
      isLoading={isLoading}
      linkUrl={`${baseUrl}/create-pm-list/${match.params.id}`}
    >
      <div className="field-wrapper">
        {listData &&
          listData.length > 0 &&
          listData[0].details.length > 0 &&
          listData[0].details.map((obj) => {
            return (
              <CardSection
                title={
                  obj.category_name
                    ? obj.category_name
                    : localization.customCategory
                }
                remove={true}
                removeIt={(val) => {
                  if (val) {
                    removeCategory(obj.material_id);
                  }
                }}
              >
                <div className="details-listing">
                  <DivLayout
                    heading={localization.productType}
                    data={obj.material_name}
                  />
                </div>
              </CardSection>
            );
          })}
      </div>

      <div className="d-inline-block Gate-check-btn">
        <Button
          onClick={() => setIsModal(true)}
          className="btn btn-transparent"
        >
          {localization.addCategory}
        </Button>{' '}
        <Button onClick={() => submitData(true)} className="btn btn-primary">
          {localization.submit} <img src={Images?.ArrowRight} alt="" />
        </Button>
      </div>

      <ModalPop
        title={localization.addCategory}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
        isLoading={isLoading}
      >
        <div className="text-center">
          <DropDownInput
            label={localization.type}
            required
            isStarRequired={true}
            data={typeData && typeData}
            errorMsg={localization.isRequired}
            getIdValue={(val) => {
              if (val.id !== '') {
                setAddList({ ...addList, category_type: val.id });
                // if(val.id ===2) {
                //   fetchSubCategoryType(val.id);
                // } else {
                setIsLoading(true);
                fetchCategory(val.id);
                setIsLoading(false);
                setSelectedCategory(val.id);
                // }
              }
            }}
          />

          {categoryType && categoryType.length > 0 && (
            <DropDownInput
              label={localization.cat}
              required
              isStarRequired={true}
              data={categoryData}
              errorMsg={localization.isRequired}
              getIdValue={(val) => {
                if (val.id !== '') {
                  setAddList({
                    ...addList,
                    category_id: val.id,
                    category_name: val.value,
                    material_id: '',
                    material_name: '',
                  });
                  if (selectedCategory !== 2) {
                    setIsLoading(true);
                    fetchSubCategoryType(val.id);
                    setIsLoading(false);
                  }
                }
              }}
            />
          )}

          {subCategoryType &&
            subCategoryType.length > 0 &&
            selectedCategory !== 2 && (
              <DropDownInput
                label={localization.product}
                required
                isStarRequired={true}
                data={materialData}
                errorMsg={localization.isRequired}
                getIdValue={(val) => {
                  if (val.id !== '') {
                    setAddList({
                      ...addList,
                      material_id: val.id,
                      material_name: val.value,
                    });
                  }
                }}
              />
            )}
          <Button
            className="btn btn-primary mb-4"
            onClick={() => addCategory()}
            isLoadingisLoading
            disabled={isClicked}
          >
            {localization.addCategory} <img src={Images?.ArrowRight} alt="" />
          </Button>
        </div>
      </ModalPop>

      <ModalPop
        title={localization.conf}
        show={modalSuccess}
        handleModalHide={modalSuccessHide}
        keyboard
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.saveSuccessfully}</h5>

          <Link
            to={`${baseUrl}/create-pm-list/${match.params.id}`}
            className="btn btn-primary mb-4"
          >
            {localization.viewPMChecklist}
            <img src={Images?.arrowRightBlue} alt="" />
          </Link>
        </div>
      </ModalPop>
    </Layout>
  );
};
export default PmChecklist;
